import { combineReducers } from 'redux';
import { reducer } from 'redux-oidc';

import authReducer from '../ducks/auth';
import userReducer from '../ducks/users';
import roleReducer from '../ducks/roles';
import intlReducer from '../ducks/intl';

export function createRootReducer() {
  return combineReducers({
    oidc: reducer,
    auth: authReducer,
    users: userReducer,
    roles: roleReducer,
    intl: intlReducer,
  });
}
